module.exports = __webpack_public_path__ + "static/media/ic-keyboard-arrow-right-white.fde05e94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-keyboard-arrow-right-white.svg
// module id = 1365
// module chunks = 0